import type { RestorePointDay } from "../api/types";
import { common } from "../i18n/common";
import { useT } from "../i18n/core";
import { useFormat } from "../lib/format";

/**
 * Régua de pontos de restauração: um traço por dia, do mais antigo ao mais
 * novo. Estado codificado por cor e por altura (falha é mais baixa, sem
 * backup é só o contorno), para não depender só de cor.
 */
export function RestoreStrip({ days, size = "normal" }: { days: RestorePointDay[]; size?: "mini" | "normal" | "big" }) {
  const t = useT(common);
  const f = useFormat();
  const ok = days.filter((d) => d.state === "ok" || d.state === "partial").length;
  const failed = days.filter((d) => d.state === "failed").length;
  return (
    <div>
      <div className={`strip ${size === "normal" ? "" : size}`} role="img" aria-label={t.stripSummary(ok, days.length, failed)}>
        {days.map((d) => (
          <span key={d.date} className={`d ${d.state === "ok" ? "" : d.state}`} title={`${f.dayMonth(d.date)}: ${t.dayState[d.state]}`} />
        ))}
      </div>
      {size === "big" && days.length > 0 && (
        <div className="strip-axis" aria-hidden="true">
          <span>{f.dayMonth(days[0]!.date)}</span>
          <span>{f.dayMonth(days[Math.floor(days.length / 2)]!.date)}</span>
          <span>{t.today}</span>
        </div>
      )}
    </div>
  );
}

export function RestoreStripLegend() {
  const t = useT(common);
  return (
    <div className="strip-legend">
      <span><i style={{ height: 12, background: "var(--ok-mark)" }} />{t.dayLegend.ok}</span>
      <span><i style={{ height: 12, background: "linear-gradient(to top, var(--warn-mark) 55%, transparent 55%)", boxShadow: "inset 0 0 0 1px var(--warn-mark)" }} />{t.dayLegend.partial}</span>
      <span><i style={{ height: 7, background: "var(--crit-mark)" }} />{t.dayLegend.failed}</span>
      <span><i style={{ height: 4, boxShadow: "inset 0 0 0 1px var(--line-strong)" }} />{t.dayLegend.none}</span>
    </div>
  );
}
